/* eslint-disable react/display-name */
import React from 'react';
import {
  number,
  string,
  shape,
  arrayOf,
  oneOfType,
  func,
} from 'prop-types';

import SwitchPanel from './SwitchPanel';
import SliderPanel from './SliderPanel';
import NumberInputPanel from './NumberInputPanel';
import SelectPanel from './SelectPanel';

const Filter = React.memo(({
  filter: {
    selectStyle,
    amountStyle,
  },
  filter,
  onChange,
  onBlur,
  value,
}) => {
  switch (amountStyle) {
    case 'Select':
      return (
        <SelectPanel
          {...filter}
          onChange={onChange}
          value={value}
        />
      );
    case 'Slider':
      return (
        <SliderPanel
          {...filter}
          /* NOTE:
            We use uncontrolled mode to enable
            fast update of input value during slider dragging
          */
          defaultValue={value}
          onChange={onChange}
          onBlur={onBlur}
        />
      );
    case 'NumberInput':
      return (
        <NumberInputPanel
          {...filter}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          type="tel"
        />
      );
    case 'DirectEntry':
      return (
        <NumberInputPanel
          {...filter}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          type="tel"
        />
      );
    case 'Calculated':
      return (
        <NumberInputPanel
          {...filter}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          type="calculated"
          disabled
        />
      );
    default:
      break;
  }

  switch (selectStyle) {
    case 'slider':
      return (
        <SliderPanel
          {...filter}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={value}
        />
      );
    case 'Multi':
      return (
        <SwitchPanel
          {...filter}
          onChange={onChange}
          value={typeof value === 'string' ? [value] : value}
        />
      );
    case 'Switch':
      return (
        <SwitchPanel
          {...filter}
          onChange={onChange}
          value={typeof value === 'string' ? [value] : value}
        />
      );
    case 'period':
      return (
        <NumberInputPanel
          {...filter}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
        />
      );
    case 'flatSize':
      return (
        <NumberInputPanel
          {...filter}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
        />
      );
    case 'Single':
      return (
        <SelectPanel
          {...filter}
          onChange={onChange}
          value={value}
        />
      );
    default:
      return null;
  }
});

Filter.propTypes = {
  value: oneOfType([arrayOf(string), number, string, shape({}), arrayOf(shape({}))]),
  filter: shape({}),
  onChange: func,
  onBlur: func,
};

Filter.defaultProps = {
  value: null,
  filter: {},
  onChange: undefined,
  onBlur: undefined,
};

export default Filter;
